import api from "./apiConfig";

export const CREATE_FICHA_TECNICA = async (data) => {
	try {
		const response = await api.post("/technicalSpecificationsController", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_FICHA_TECNICA_BY_CASO = async (id) => {
	try {
		const response = await api.get(`/technicalSpecificationsByTaxMatterId/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_FICHA_TECNICA = async (id, data) => {
	try {
		const response = await api.put(`/technicalSpecificationsController/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};